import request from '../../../../api/request';
import { ACADEMIC_STRUCTURE } from '../../../../api/endpoints';
import { SchoolsListResponse } from '../../../../api/requests/schools';

import { StudentListQuery, StudentListResponse } from './types';

const STUDENT_LIST = {
  LIST: '/maintainers-portal/financial-portal/current-account/students',
};

/**
 * Loads all schools (paginated with a high limit) for the filter dropdown.
 */
export function getSchoolsForSelect() {
  return request<SchoolsListResponse>(ACADEMIC_STRUCTURE.SCHOOLS, {
    params: { items_per_page: 500, page: 0 },
  });
}

/**
 * Loads all study plans for the filter dropdown.
 * Uses GET /study-plans/all which returns all study plans as an array.
 */
export function getStudyPlansForSelect() {
  return request<{ data: Array<{ id: number; name: string }> }>(
    '/study-plans/all',
  );
}

/**
 * Fetches the paginated list of students for the Portal Financiero.
 * Supports optional filter params (identification, name, schoolId, etc.).
 */
export function getStudentList(query: StudentListQuery) {
  const params: Record<string, string | number> = {
    page: query.page,
    items_per_page: query.items_per_page,
  };

  if (query.identificationTypeId != null) {
    params.identificationTypeId = query.identificationTypeId;
  }
  if (query.identification) {
    params.identification = query.identification;
  }
  if (query.name) {
    params.name = query.name;
  }
  if (query.schoolId != null) {
    params.schoolId = query.schoolId;
  }
  if (query.studyPlanId != null) {
    params.studyPlanId = query.studyPlanId;
  }
  if (query.financialStatus) {
    params.financialStatus = query.financialStatus;
  }
  if (query.overdueDays != null) {
    params.overdueDays = query.overdueDays;
  }

  return request<StudentListResponse>(STUDENT_LIST.LIST, {
    method: 'get',
    params,
  });
}

const FINANCIAL_STATUS = {
  TEMPORARY_UNBLOCK: (studentId: number) =>
    `/maintainers-portal/financial-portal/current-account/students/${studentId}/temporary-unblock`,
};

/** POST — Create temporary unblock for a student. */
export function createTemporaryUnblock(
  studentId: number,
  body: { from: string; until: string },
) {
  return request(FINANCIAL_STATUS.TEMPORARY_UNBLOCK(studentId), {
    method: 'post',
    data: body,
  });
}

/** DELETE — Remove temporary unblock, revert to financial block. */
export function removeTemporaryUnblock(studentId: number) {
  return request(FINANCIAL_STATUS.TEMPORARY_UNBLOCK(studentId), {
    method: 'delete',
  });
}
